// auth.service.ts
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { IServicios } from '../../models/web/IServicios';
import { AuthWebService } from './auth-web.service';

@Injectable({
	providedIn: 'root'
})
export class GetServiciosWebService {
	private http = inject(HttpClient);
	private authService = inject(AuthWebService);
	token = this.authService.obtenerToken();

	getAreas(): Observable<any[]> {
		const headers = new HttpHeaders({
			Authorization: 'Basic ' + btoa(`${environment.authWebUsername}:${environment.authWebPassword}`),
			'Content-Type': 'application/json'
		});
		return this.http.get<any[]>(`${environment.apiWebUrl}/areas`, { headers });
	}
	// Autenticación automática al cargar la web
	getservicios() {
		const headers = new HttpHeaders({
			Authorization: 'Basic ' + btoa(`${environment.authWebUsername}:${environment.authWebPassword}`),
			'Content-Type': 'application/json'
		});

		return this.http.get<IServicios[]>(`${environment.apiWebUrl}/servicios`, { headers });
	}

	getservicio(slug: string) {
		const headers = new HttpHeaders({
			Authorization: 'Basic ' + btoa(`${environment.authWebUsername}:${environment.authWebPassword}`),
			'Content-Type': 'application/json'
		});
		return this.http.get<IServicios>(`${environment.apiWebUrl}/servicios/${slug}`, { headers });
	}
}
